import React from "react";

import { fetchInterval } from "../config";
import variableColors from "../_App.module.scss";

const { breakPointSmall, breakPointMedium } = variableColors;

const useNetworkStatus = (): { isOnline: boolean; isMobile: boolean; isAlLeastSmall: boolean; isAlLeastMedium: boolean } => {
  // console.log('window.matchMedia("(max-width: 768px)").matches', window.matchMedia("(max-width: 768px)").matches);

  const [isOnline, setIsOnline] = React.useState<boolean>(typeof window !== "undefined" ? window.navigator.onLine : true);
  const [isMobile, setIsMobile] = React.useState<boolean>(true);
  const [width, setWidth] = React.useState<number>(window.innerWidth);
  // console.log("width:", width);

  React.useEffect(() => {
    // Create event handler
    const handleStatusChange = () => {
      setIsOnline(navigator.onLine);
    };

    // Listen for online and offline events
    window.addEventListener("online", handleStatusChange);
    window.addEventListener("offline", handleStatusChange);

    // Clean up to avoid memory-leak
    return () => {
      window.removeEventListener("online", handleStatusChange);
      window.removeEventListener("offline", handleStatusChange);
    };
  }, []);

  React.useEffect(() => {
    const isMobileCheck = (): boolean => {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    };

    const setCheckInterval = () => {
      setIsMobile(isMobileCheck());
    };
    setCheckInterval();
    const checkingInterval = setInterval(setCheckInterval, fetchInterval) as NodeJS.Timer;
    return () => {
      clearInterval(checkingInterval);
    };
  }, []);

  React.useEffect(() => {
    const handleResize = (): void => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isAlLeastSmall: boolean = width >= Number(breakPointSmall);
  // console.log("isAlLeastSmall:", isAlLeastSmall);

  const isAlLeastMedium: boolean = width >= Number(breakPointMedium);

  return { isOnline, isMobile, isAlLeastSmall, isAlLeastMedium };
};

export default useNetworkStatus;
